{
  "cancel": {},
  "fail": {
    "back": {},
    "cancel": {},
    "tryAgain": {}
  },
  "name": {},
  "report": {},
  "run": {},
  "success": {
    "close": {}
  },
  "value": {}
}
